import { Stack } from '@mui/material'
import type { ReactNode } from 'react'

import { BodyText } from '@/components/atoms/BodyText'
import type { YakurekiDetail } from '@/shared/types/yakurekiCore'

import type { GuidanceAudit, GuidanceSupportDataV3 } from '../../types'
import { formatMonthDayTime } from '../../utils/formatPrepDate'
import { GuidanceCheckPointList } from '../GuidanceCheckPointList'
import { KasanStatusPanel } from '../KasanStatusPanel'
import { TracingReportPrepRow } from '../GuidancePrepPaneV3/TracingReportPrepRow'
import { EmptyLine, PrepSection } from './parts'
import { PreviousDiffSection } from './PreviousDiffSection'

interface Props {
  event: YakurekiDetail
  // 指導前準備 (completed のときだけ). それ以外は pending を出す
  data: GuidanceSupportDataV3 | null
  pending: ReactNode
  audit: GuidanceAudit | null
}

// 服薬指導の面 (最初に開く面). 投薬する人が見るものだけを置く:
//   申し送り → 確認要点 → 前回との差 → 加算
// 禁忌の ● は監査の面に寄せる (yakureki-back log/262 決定 1). 前回との差は両方の面に置く (決定 15).
export const GuidanceFace = ({ event, data, pending, audit }: Props) => {
  const eventId = event.id
  const auditedAt = audit ? formatMonthDayTime(audit.auditedAt) : null
  const auditAside = audit
    ? ['監査', auditedAt, audit.auditedBy].filter(Boolean).join(' ')
    : '監査はまだ'
  return (
    <Stack spacing={2}>
      <PrepSection title="申し送り" aside={auditAside}>
        {audit?.handoverNote ? (
          <BodyText sx={{ whiteSpace: 'pre-wrap' }}>
            {audit.handoverNote}
          </BodyText>
        ) : (
          <EmptyLine />
        )}
      </PrepSection>

      <PrepSection title="確認要点">
        {data ? (
          <>
            <GuidanceCheckPointList
              points={data.checkPoints}
              showsContraindication={false}
              showsQuestion
            />
            {/* トレーシングレポートのルール検知行 (該当時のみ描画) */}
            <TracingReportPrepRow yakurekiId={eventId} />
          </>
        ) : (
          pending
        )}
      </PrepSection>

      <PreviousDiffSection event={event} isInitial={!!data?.isInitial} />

      <PrepSection title="加算">
        <KasanStatusPanel yakurekiId={eventId} />
      </PrepSection>
    </Stack>
  )
}
